/**
 * Parse a free-form "To:" string into trimmed email addresses.
 * Splits on commas, semicolons, newlines, and whitespace; keeps only
 * tokens that contain '@'. Used by the share modals to allow multi-
 * recipient entry in a single text field.
 */
export function parseEmailList(input) {
  if (!input) return [];
  return String(input)
    .split(/[,;\s\n]+/)
    .map(s => s.trim())
    .filter(s => s.includes('@') && s.length > 2);
}
